export default {
  MENU: {
    '01': {
      // 菜单路由地址
      path: '/security/home',
      // 菜单路由名称，使用国际化
      name: 'system.menu.0',
      // 菜单对应的图标地址
      icon: 'ioc-Gate',
    },
    // 综合态势
    // 菜单ID，该ID与后台的ID值一一对应
    '02': {
      // 菜单路由地址
      path: '/zonghetaishi',
      // 菜单路由名称，使用国际化
      name: 'system.menu.11',
      // 菜单对应的图标地址
      icon: 'icon-lunan-lujing2',
    },
    // 综合安防
    '03': {
      path: '/zongheanfang',
      name: 'system.menu.12',
      icon: 'icon-lunan-lujing4',
    },
    //视频监控
    '030101': {
      path: '/video/realtime',
      name: 'system.menu.1201',
    },
    // 实时告警
    '030201': {
      path: '/realTimeAlarm',
      name: 'system.menu.1101',
    },
    // 告警记录
    '030202': {
      path: '/historyAlarm',
      name: 'system.menu.110101',
    },
    // 任务管理
    '030203': {
      path: '/taskCenter/list',
      name: 'system.menu.120203',
    },
    // 巡逻计划
    '030301': {
      path: '/videoPatrol/plan',
      name: 'system.menu.120301',
    },
    // 实时巡逻
    '030302': {
      path: '/videoPatrol/task',
      name: 'system.menu.120302',
    },
    // 巡逻历史
    '030303': {
      path: '/videoPatrol/history',
      name: 'system.menu.120303',
    },
    // 巡更计划
    '030601': {
      path: '/elePatrol-patrolplan',
      name: 'system.menu.120401',
    },
    // 巡更记录
    '030602': {
      path: '/elePatrol-patrolrecord',
      name: 'system.menu.120402',
    },
    // 视频周界
    '030701': {
      path: '/perimeter',
      name: 'system.menu.120501',
    },
    // 工单管理
    '030801': {
      path: '/workorder/index',
      name: 'system.menu.120601',
    },
    // 通行管理
    '04': {
      path: '/tongxing',
      name: 'system.menu.12',
      icon: 'icon-lunan-lujing5',
    },
    // 人员名单管理
    '040401': {
      path: '/personMg',
      name: 'system.menu.130101',
    },
    // 人员布控
    '040402': {
      path: '/personControl/manage',
      name: 'system.menu.130102',
    },
    // 人员研判
    '040403': {
      path: '/personResearch',
      name: 'system.menu.130103',
    },
    // 人员信息
    '040404': {
      path: '/peopleInfo',
      name: 'system.menu.130104',
    },
    // 车间记录
    '040405': {
      path: '/workshopAproval',
      name: 'system.menu.130105',
    },

    // 车辆名单管理
    '040501': {
      path: '/carPatrolBlack',
      name: 'system.menu.130201',
    },
    // 车辆布控
    '040502': {
      path: '/carPatrol/index',
      name: 'system.menu.130202',
    },
    // 车辆研判
    '040503': {
      path: '/carResearch',
      name: 'system.menu.130203',
    },
    // 测速配置
    '040504': {
      path: '/carspeed/speedConfig',
      name: 'system.menu.130204',
    },
    // 超速记录
    '040505': {
      path: '/carspeed/speedRecord',
      name: 'system.menu.130205',
    },
    // 车辆审批记录
    '040506': {
      path: '/carApprovalRecord',
      name: 'system.menu.130206',
    },
    // 识别中心
    '040601': {
      path: '/access/identifyCenter',
      name: 'system.menu.130301',
    },
    // 识别记录
    '040602': {
      path: '/access/identifyRecord',
      name: 'system.menu.130302',
    },
    // 预约记录
    '040701': {
      path: '/access/visitorRecord',
      name: 'system.menu.130401',
    },
    // 消防管理
    '05': {
      path: '/xiaofangguanli',
      name: 'system.menu.12',
      icon: 'icon-lunan-xiaofangguanli',
    },
    // 资产管理
    '0501': {
      path: '/assets/assetsManage',
      name: 'system.menu.1401',
    },
    // 资产归领管理
    '0502': {
      path: '/assets/assetsRecipient',
      name: 'system.menu.1402',
    },
    // 资产巡检
    '0503': {
      path: '/assetinspection/inspectionPlan',
      name: 'system.menu.1403',
    },
    // 巡检记录
    '0504': {
      path: '/assetinspection/inspectionRecord',
      name: 'system.menu.1404',
    },
    // 联动规则
    '900101': {
      path: '/linkage/Ruleset',
      name: 'system.menu.150101',
    },
    // 预案管理
    '06': {
      path: '/yuanliandong',
      name: 'system.menu.13',
      icon: 'icon-lunan-lujing6',
    },
    // 联动日志
    '900102': {
      path: '/linkage/LinkageTriggerLog',
      name: 'system.menu.150102',
    },
    // 预案配置
    '900202': {
      path: '/reserve/reserveplan',
      name: 'system.menu.150201',
    },
    // 预案执行
    '900203': {
      path: '/reserveImplement',
      name: 'system.menu.150202',
    },
    // 预案记录
    '900204': {
      path: '/reserve/reserveRecord',
      name: 'system.menu.150203',
    },
        // 园区管理
    '07': {
      path: '/',
      icon: 'iconyuanquguanli',
    },
    // 能效管理
    '10': {
      path: '/',
      icon: 'iconnengxiao1',
    },
    // 智慧冷链
    '11': {
      path: '/',
      icon: 'iconlenglian1',
    },
    // 智慧月台
    '12': {
      path: '/',
      icon: 'iconyuetai1',
    },
    // 场站调度
    '13': {
      path: '/',
      icon: 'icontiaodu1',
    },
    // 设备管理
    '98': {
      path: '/shebeiguanli',
      name: 'system.menu.16',
      icon: 'icon-lunan-lujing1',
    },
    // 设备接入
    '980101': {
      path: '/deviceaccess/index',
      name: 'system.menu.160101',
    },
    // 设备列表
    '980102': {
      path: '/cameralist/devicelist',
      name: 'system.menu.160102',
    },
    // 摄像机组管理
    '980103': {
      path: '/deviceMg/carameGroup',
      name: 'system.menu.160103',
    },
    // 事件配置
    '980104': {
      path: '/deviceaccess/eventconfignew',
      name: 'system.menu.160104',
    },
    // 系统管理
    '99': {
      path: '/xitongguanli',
      name: 'system.menu.18',
      icon: 'icon-lunan-xitongshezhi',
    },
    // 账户管理
    '9901': {
      path: '/account/index',
      name: 'system.menu.1701',
    },
    // 角色管理
    '9902': {
      path: '/accountgroup',
      name: 'system.menu.1702',
    },
    // 工作组管理
    '9903': {
      path: '/workGroup/index',
      name: 'system.menu.1703',
    },
    // 区域管理
    '9904': {
      path: '/area',
      name: 'system.menu.1704',
    },
    // 日志管理
    '9905': {
      path: '/log',
      name: 'system.menu.1705',
    },
    // 系统参数设置
    '9906': {
      path: '/system',
      name: 'system.menu.1703',
    },
    // 保卫换岗记录
    '9907': {
      path: '/securityShift',
      name: 'system.menu.1704',
    },
    // 系统配置
    1901: {
      path: '/ThemeCustom',
      name: 'system.menu.1802',
      icon: 'ioc-Copy',
    },
    // 主题配置
    190102: {
      path: '/ThemeCustom',
      name: 'system.menu.190102',
      icon: 'ioc-Report_view',
    },
  },
}
